import * as React from 'react'
import './index.css'
import { BrandLogo } from '../../../../components'
import PageTitle from '../PageTitle'
import { LayoutProps } from '../../type'
import { useLocation } from 'react-router-dom'

const Layout = ({
    children,
    pageDescription,
    pageTitle,
    pageBody,
}: LayoutProps) => {
    const location = useLocation()
    return (
        <>
            <section className="auth">
                <div className="auth-left">
                    <BrandLogo />
                    <PageTitle
                        pageTitle={pageTitle}
                        pageDescription={pageDescription || ''}
                        pageBody={pageBody}
                    />
                    {children}
                </div>
                <div className="auth-right">
                    {location.pathname !== '/logout' && (
                        <div className="login-bg"></div>
                    )}
                    <div
                        className={
                            location.pathname === '/logout'
                                ? 'logout-screen'
                                : ''
                        }
                    ></div>
                </div>
            </section>
        </>
    )
}
export default Layout
